import React, { useEffect, useState } from "react";
import { Loader2, RefreshCw, Power } from "lucide-react";
import { api } from "../../api";

const AdminSubscriptions = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/subscriptions").then((r) => setSubs(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const toggle = async (id) => { await api.post(`/admin/subscriptions/${id}/toggle`); load(); };

  const active = subs.filter((s) => s.active).length;
  const mrr = subs.filter((s) => s.active).reduce((t, s) => t + (s.price || 0), 0);

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-display text-3xl font-bold uppercase text-[#1B2a21]">Subscriptions</h1>
      <p className="mb-6 text-[#6b7d72]">Auto monthly deliveries · an email is sent automatically each month</p>

      <div className="mb-5 grid grid-cols-3 gap-4">
        <div className="rounded-2xl border border-[#e6f0ea] bg-white p-5"><p className="font-display text-3xl font-bold text-[#1B2a21]">{subs.length}</p><p className="text-sm text-[#6b7d72]">Total</p></div>
        <div className="rounded-2xl border border-[#e6f0ea] bg-white p-5"><p className="font-display text-3xl font-bold text-[#1B2a21]">{active}</p><p className="text-sm text-[#6b7d72]">Active</p></div>
        <div className="rounded-2xl border border-[#e6f0ea] bg-white p-5"><p className="font-display text-3xl font-bold text-[#1B2a21]">£{mrr.toFixed(2)}</p><p className="text-sm text-[#6b7d72]">Monthly recurring</p></div>
      </div>

      {loading ? <Loader2 className="animate-spin text-[#2D6A4F]" /> : (
        <div className="overflow-x-auto rounded-2xl border border-[#e6f0ea] bg-white">
          <table className="w-full min-w-[720px] text-left text-sm">
            <thead className="bg-[#f0f7f2] font-display text-xs uppercase tracking-wider text-[#2D6A4F]"><tr><th className="p-4">Customer</th><th className="p-4">Product</th><th className="p-4">Price/mo</th><th className="p-4">Next delivery</th><th className="p-4">Status</th><th className="p-4 text-right">Action</th></tr></thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.sub_id} className="border-t border-[#f0f5f2]">
                  <td className="p-4">{s.customer_name}<br /><span className="text-xs text-[#8aa093]">{s.customer_email}</span></td>
                  <td className="p-4 text-[#34463c]">{s.product_name}</td>
                  <td className="p-4 font-semibold text-[#1B4332]">£{Number(s.price).toFixed(2)}</td>
                  <td className="p-4 text-[#6b7d72]">{(s.next_charge_date || "").slice(0, 10)}</td>
                  <td className="p-4"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${s.active ? "bg-[#e3f3ea] text-[#2D6A4F]" : "bg-[#f0f0f0] text-[#999]"}`}>{s.active ? "Active" : "Paused"}</span></td>
                  <td className="p-4 text-right"><button onClick={() => toggle(s.sub_id)} className="inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-semibold text-[#2D6A4F] hover:bg-[#f0f7f2]"><Power size={14} /> {s.active ? "Pause" : "Resume"}</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminSubscriptions;
